const types = {
  SWITCH_TYPE: 'SWITCH_TYPE',
  REFRESH_TOPICS: 'REFRESH_TOPICS',
  REQUEST_TOPICS: 'REQUEST_TOPICS',
  RECEIVE_TOPICS_SUCCESS: 'RECEIVE_TOPICS_SUCCESS',
  RECEIVE_TOPICS_FAILURE: 'RECEIVE_TOPICS_FAILURE',
  REQUEST_TOPIC: 'REQUEST_TOPIC',
  RECEIVE_TOPIC_SUCCESS: 'RECEIVE_TOPIC_SUCCESS',
  RECEIVE_TOPIC_FAILURE: 'RECEIVE_TOPIC_FAILURE',
  REFRESH_NODES: 'REFRESH_NODES',
  REQUEST_NODES: 'REQUEST_NODES',
  RECEIVE_NODES_SUCCESS: 'RECEIVE_NODES_SUCCESS',
  RECEIVE_NODES_FAILURE: 'RECEIVE_NODES_FAILURE',
  REQUEST_REPLIES: 'REQUEST_REPLIES',
  RECEIVE_REPLIES_SUCCESS: 'RECEIVE_REPLIES_SUCCESS',
  RECEIVE_REPLIES_FAILURE: 'RECEIVE_REPLIES_FAILURE',
};
export default types;



// WEBPACK FOOTER //
// ./src/store/mutation-types.js